import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "host-display" }

import { useTypewriter } from '@/composables/useTypewriter';


export default /*@__PURE__*/_defineComponent({
  __name: 'HostDisplay',
  props: { message: { type: String, required: true } },
  setup(__props) {

const props = __props;
const { displayedText, isTyping } = useTypewriter(() => props.message);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, [
      _createTextVNode(_toDisplayString(_unref(displayedText)), 1),
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "cursor" }, null, -1))
    ])
  ]))
}
}

})